module.exports = __webpack_public_path__ + "static/media/remove-2.0d8866ec.svg";